import React, { useEffect } from 'react';
import { IItemForGetShortInfo, IGetSubCategoriesShort, IGetSubCategoriesArguments } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getSubCategoriesShortInfoV2 } from 'backend/subcategories';
import FormSelect from 'components/Select/FormSelect';
import style from './AdditionalDishSubCategorySelect.module.scss';

interface IProps {
	setFetchedAdditionalDishSubCategories: (value: IItemForGetShortInfo[]) => void;
	setAdditionalDishSubCategory: (value: Nullable<string>) => void;
	selectedAdditionalDishCategory: Nullable<string>;
}

export const AdditionalDishSubCategorySelect: React.FC<IProps> = React.memo(
	({ setFetchedAdditionalDishSubCategories, setAdditionalDishSubCategory, selectedAdditionalDishCategory }) => {
		const { response, loading, refetch, responseError } = useFetchData<
			IGetSubCategoriesShort,
			IGetSubCategoriesArguments
		>(selectedAdditionalDishCategory ? getSubCategoriesShortInfoV2 : null, {
			categoryId: selectedAdditionalDishCategory ? selectedAdditionalDishCategory : '',
		});

		useEffect(() => {
			refetch();
		}, [selectedAdditionalDishCategory]);

		useEffect(() => {
			response && setFetchedAdditionalDishSubCategories(response.data.subCategories);
		}, [response]);

		return (
			<FormSelect
				name="selectedAdditionalDishSubCategory"
				label="subcategoryLabel"
				formItemClassName={style.container}
				options={response?.data.subCategories}
				fetchError={responseError}
				loading={loading}
				onRefetch={refetch}
				disabled={!selectedAdditionalDishCategory || loading}
				onChange={setAdditionalDishSubCategory}
				onMouseDown={(e) => e.stopPropagation()}
				onClick={(e) => e.stopPropagation()}
			/>
		);
	},
);
